Vue.component('ranking-table', {
  props: {
    series: {
      type: Object,
      default: () => {
        return {}
      },
    },
    teams: {
      type: Array,
      default: () => {
        return []
      },
    },
    noDetail: {
      type: Boolean,
      default: false,
    },
  },
  template: `
<div>
  <div class="table-container">
    <table class="ranking-table table is-striped is-fullwidth">
      <thead>
        <tr>
          <th class="has-text-centered">順位</th>
          <th class="pl-5">チーム名</th>
          <template v-if="!noDetail">
            <th class="has-text-centered">勝点</th>
            <th class="has-text-centered">試合数</th>
            <th class="has-text-centered">勝</th>
            <th class="has-text-centered">分</th>
            <th class="has-text-centered">負</th>
            <th class="has-text-centered">得失点</th>
            <th class="has-text-centered">得点</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(team, i) in teamRankingList" :key="i">
          <td class="has-text-centered">{{ data(team, 'rank') }}</td>
          <td>{{ team.shortName }}</td>
          <template v-if="!noDetail">
            <td class="has-text-centered">{{ data(team, 'point') }}</td>
            <td class="has-text-centered">{{ data(team, 'gameCount') }}</td>
            <td class="has-text-centered">{{ data(team, 'win') }}</td>
            <td class="has-text-centered">{{ data(team, 'draw') }}</td>
            <td class="has-text-centered">{{ data(team, 'lose') }}</td>
            <td class="has-text-centered">{{ data(team, 'goalDifferential') }}</td>
            <td class="has-text-centered">{{ data(team, 'score') }}</td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</div>`,
  data() {
    return {
      localTeams: null,
    }
  },
  /*
  watch: {
    seriesId() {
      this.update()
   },
  },
  */
  computed: {
    seriesId() {
      return _.get(this.series, ['_id'], '')
    },
    teamIds() {
      return (this.localTeams || this.teams).map((item) => {
        return item._id
      })
    },
    teamRankingList() {
      return (this.localTeams || this.teams).slice().sort((a, b) => {
        const ar = parseInt(_.get(a, ['rankingData', 'rank'], 100), 10)
        const br = parseInt(_.get(b, ['rankingData', 'rank'], 100), 10)
        if (ar !== br) {
          return ar - br
        }
        const ai = _.indexOf(this.teamIds, parseInt(_.get(a, ['teamId'], 0), 10))
        const bi = _.indexOf(this.teamIds, parseInt(_.get(b, ['teamId'], 0), 10))
        return bi - ai
      })
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    data(team, key) {
      return _.get(team, ['rankingData', key], '-')
    },
    async fetch() {
      if (!this.seriesId) {
        return
      }

      const { data: { entries } } = await axios.post('/api/collections/get/seriesTeams', {
        filter: { seriesId: this.seriesId },
      })

      this.localTeams = entries
    },
  },
})
